var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8468",
    "data-name": "Group 8468",
    transform: "translate(5179 2585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-dashboard-3846734",
    d: "M171.023,95.435v7.452a1.8,1.8,0,0,1-1.8,1.8h-3.786a1.8,1.8,0,0,1-1.8-1.8V95.435a1.8,1.8,0,0,1,1.8-1.8h3.786a1.8,1.8,0,0,1,1.8,1.8Zm-1.8,10.625h-3.786a1.8,1.8,0,0,0-1.8,1.8v3.966a1.8,1.8,0,0,0,1.8,1.8h3.786a1.8,1.8,0,0,0,1.8-1.8v-3.966a1.8,1.8,0,0,0-1.8-1.8Zm12.608-4.435H174.2a1.8,1.8,0,0,0-1.8,1.8v8.4a1.8,1.8,0,0,0,1.8,1.8h7.632a1.8,1.8,0,0,0,1.8-1.8v-8.4a1.8,1.8,0,0,0-1.8-1.8Zm0-7.993H174.2a1.8,1.8,0,0,0-1.8,1.8v3.017a1.8,1.8,0,0,0,1.8,1.8h7.632a1.8,1.8,0,0,0,1.8-1.8V95.435a1.8,1.8,0,0,0-1.8-1.8Z",
    transform: "translate(-5342.631 -2678.632)",
    fill: "#49a6f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboardActive.b4af2e3386cb52a526d928df5ebabe4f.svg";
export { ForwardRef as ReactComponent };